import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';

export class RemoveUpgrader {
    private filePath: string;
    private fileWriter: FileWriter;
    private removes: any;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     * @param removes the removes.
     * @param fileName the file name.
     */
    constructor(filePath: string, removes: any, fileName?: string) {
        this.filePath = filePath;
        this.messages.notFound = `${fileName} not found at ${this.filePath}.`

        this.removes = removes;
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                this.fileWriter
                    .removeContent(this.removes)
                    .writeFile();
            } else {
                    Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
